<template>
    <v-container>
        <Subscriptions />
    </v-container>
</template>

<script>
import Subscriptions from '../../../../components/dashboard/festival/festival/Subscriptions';
import { mapActions } from 'vuex';

import { SESSION_ID } from '../../../../utils/index'
import { HOME } from '../../../../routes';
export default {
    components: { Subscriptions },
    created() {
        if (this.$user.isGuest) {
            this.$router.push({path: HOME}); //TODO check auth with globar guard
            return;
        }
        if (this.$session.get(SESSION_ID))
            this.mySubscriptions({ profile: this.$session.get(SESSION_ID).id })
    },

    methods: {
        ...mapActions('festival/festival', {
            mySubscriptions: 'mySubscriptions'
        })
    }
}
</script>